import "./Services2.module.css";
import Header from "@/reusable_sections/Header";
import ServicesHero from "./sections/ServicesHero";
import ServicesShowcase from "./sections/ServicesShowcase";
import ContactFormSidebar from "./sections/ContactFormSidebar";
import Footer from "@/reusable_sections/Footer";
export default function Services2Page() {
  return <div>
      <Header />
      <ServicesHero />
      <ServicesShowcase />
      <ContactFormSidebar />
      <Footer />
    </div>;
}